import React, { useState } from 'react';
import { useEffect } from 'react';  //added useEffect here
import Navbar from '../component/Shared/Navbar';
import Hero from '../component/Shared/Hero';
import Feedback from '../component/Shared/Feedback';
import CTAsection from '../component/Shared/CTAsection';
import Footer from '../component/Shared/Footer';
import StatisticsDashboard from '../component/About/StatisticsDashboard';
import KeyOfferingCard from '../component/About/KeyOfferingCard';
import TeamCard from '../component/About/TeamCard';
import CatalogueCard from '../component/Home/CatalogueCard';

const About = () => {

    const [keyOfferings, setKeyOfferings] = useState([
        {
            title: "PCA",
            description: "Please go to details page for more details.",
        },
        {
            title: "OE",
            description: "Please go to details page for more details.",
        },
        {
            title: "FinOps",
            description: "Please go to details page for more details.",
        }
    ])

    useEffect(() => {
        document.title = 'About | Product Catalogue'; //added to change tab title in browser
    }, []);
    return (
        <>
            <Navbar />
            <Hero />
            <div className="container">
                <section className='key-offering-section'>
                    <div className="row">
                        <div className="col-md-10 mx-auto">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <h2 className='text-center mb-5'>PCSS Key Offerings</h2>
                                </div>
                                <div className="col-md-7">
                                    <p className="mb-3">The Public Cloud Shared Services (PCSS) team is dedicated to delivering innovative, secure, and scalable cloud solutions. We streamline operations and enable organizations to thrive in a cloud-first world.</p>
                                    <p className="mb-3">Our team of experts is committed to providing top-notch services to our customers. We are dedicated to delivering innovative, secure, and scalable cloud solutions. We streamline operations and enable organizations to thrive in a cloud-first world.</p>
                                    <p className="mb-3">We are committed to providing top-notch services to our customers. We are dedicated to delivering innovative, secure, and scalable cloud solutions. We streamline operations and enable organizations to thrive in a cloud-first world.</p>
                                    <StatisticsDashboard />
                                    
                                </div>
                                <div className="col-md-5">
                                    <div className="row">
                                        <div className="col-6">
                                            <KeyOfferingCard />
                                        </div>
                                        <div className="col-6 mt-4">
                                            <KeyOfferingCard />
                                        </div>
                                        <div className="col-6">
                                            <KeyOfferingCard />
                                        </div>
                                        <div className="col-6 mt-4">
                                            <KeyOfferingCard />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="pcss-team-section">
                    <div className="col-md-10 mx-auto">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <h2 className='text-center mb-5'>PCSS Key Offerings</h2>
                            </div>
                            <p className="text-center mb-5">The Public Cloud Shared Services (PCSS) team is dedicated to delivering innovative, secure, and scalable cloud solutions. We streamline operations and enable organizations to thrive in a cloud-first world.</p>
                            <div className="row">
                                <div className="col-md-10 mx-auto">
                                    <div className="row ">
                                        <div className="col-md-4">
                                            <TeamCard />
                                        </div>
                                        <div className="col-md-4">
                                            <TeamCard />
                                        </div>
                                        <div className="col-md-4">
                                            <TeamCard />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="featured-section mb-5">
                    <div className="col-md-10 mx-auto">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <h2 className='text-center mb-5'>PCSS Key Offerings</h2>
                            </div>
                            <p className="text-center mb-5">The Public Cloud Shared Services (PCSS) team is dedicated to delivering innovative, secure, and scalable cloud solutions. We streamline operations and enable organizations to thrive in a cloud-first world.</p>
                            <div className="row">
                                <div className="col-md-10 mx-auto">
                                    <div className="row ">
                                        {
                                            keyOfferings.map((keyOffering, index) =>
                                                <div className="col-md-4" key={index}>
                                                    <CatalogueCard title={keyOffering.title} name={keyOffering.title} description={keyOffering.description} />
                                                </div>
                                           )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Feedback />
                <CTAsection />
            </div >
            <Footer />
        </>
    );
}
export default About;
